import Layout from "@/lib/Layout";
import { Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import FormContact from "./FromContact";

const ContactView = () => {
    return (
        <Layout>
            <div className="container mx-auto max-w-4xl px-4 py-8">
                <h1 className="text-3xl sm:text-4xl font-extrabold text-center text-[#223843] mb-8">
                    تماس با هیرونیا
                </h1>

                <Section title="پشتیبانی فروشگاه">
                    <p className="text-[#606060]">
                        از <b className="text-[#2E2E2E]">شنبه تا پنج‌شنبه</b>، از ساعت <b className="text-[#2E2E2E]">10 صبح تا 10 شب</b> به صورت تلفنی در خدمت شما عزیزان هستیم.
                        همچنین می‌توانید از طریق <b className="text-[#2E2E2E]">واتساپ</b> و <b className="text-[#2E2E2E]">تلگرام</b> با ما در ارتباط باشید.
                    </p>
                </Section>

                <Section title="راه‌های ارتباطی">
                    <ContactItem icon={<MapPin className="text-[#223843]" />} label="آدرس">
                        <span className="text-[#606060]">
                            بوشهر، بندر دیلم، خیابان شریعتی جنوبی، کوچه ورزش، دفتر مرکزی هیرونیا
                        </span>
                    </ContactItem>
                    <ContactItem icon={<Phone className="text-[#223843]" />} label="شماره تماس">
                        <a href="tel:09338885007" className="text-amber-900 hover:underline font-bold">09338885007</a>
                    </ContactItem>
                    <ContactItem icon={<WhatsAppIcon />} label="واتساپ">
                        <a href="https://wa.me/989931729786" target="_blank" className="text-amber-900 hover:underline font-bold">09931729786</a>
                    </ContactItem>
                    <ContactItem icon={<MessageCircle className="text-[#223843]" />} label="تلگرام">
                        <a href="https://t.me/hirooniaomde" target="_blank" className="text-amber-900 hover:underline font-bold">@hirooniaomde</a>
                    </ContactItem>
                    <ContactItem icon={<Instagram className="text-[#223843]" />} label="اینستاگرام">
                        <a href="https://www.instagram.com/kific.o?igsh=Mm9xNjBuMjQ4dmQw" target="_blank" className="text-amber-900 hover:underline font-bold">kific.o</a>
                    </ContactItem>
                </Section>

                <Section title="انتقادات و پیشنهادات">
                    <p className="text-[#606060]">
                        اگر نظر، انتقاد یا پیشنهادی دارید، می‌توانید از طریق فرم زیر با ما در ارتباط باشید. تیم پشتیبانی هیرونیا در اسرع وقت پاسخگوی شما خواهد بود.
                    </p>
                    <div className="mt-6">
                        <FormContact />
                    </div>
                </Section>
            </div>
        </Layout>
    );
};

export default ContactView;

// بخش‌ها با تم هیرونیا
const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div className="mb-10 bg-[#F5F5F7] p-6 rounded-lg">
        <h2 className="text-xl sm:text-2xl font-bold text-[#2E2E2E] border-b border-[#223843] pb-2 mb-4">
            {title}
        </h2>
        <div className="space-y-4 text-justify leading-relaxed">
            {children}
        </div>
    </div>
);

// آیتم راه ارتباطی با ظاهر بهینه
const ContactItem = ({
    icon,
    label,
    children,
}: { icon: React.ReactNode; label: string; children: React.ReactNode }) => (
    <div className="flex items-start space-x-3 mb-4">
        <div className="flex-shrink-0 w-7 h-7">{icon}</div>
        <div>
            <div className="font-semibold text-[#2E2E2E]">{label}</div>
            <div>{children}</div>
        </div>
    </div>
);

export const WhatsAppIcon = () => (
    <svg width="16px" height="16px" viewBox="0 0 24 24" id="meteor-icon-kit__regular-whatsapp" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M20.5129 3.4866C18.2882 1.24722 15.2597 -0.00837473 12.1032 4.20445e-05C5.54964 4.20445e-05 0.216056 5.33306 0.213776 11.8883C0.210977 13.9746 0.75841 16.0247 1.80085 17.8319L0.114014 23.9932L6.41672 22.34C8.15975 23.2898 10.1131 23.7874 12.0981 23.7874H12.1032C18.6556 23.7874 23.9897 18.4538 23.992 11.8986C24.0022 8.74248 22.7494 5.71347 20.5129 3.4866ZM12.1032 21.7768H12.0992C10.3294 21.7776 8.59195 21.3025 7.06888 20.4012L6.70803 20.1874L2.96836 21.1685L3.96713 17.52L3.73169 17.1461C2.74331 15.5709 2.22039 13.7484 2.22328 11.8889C2.22328 6.44185 6.65615 2.00783 12.1072 2.00783C14.7284 2.00934 17.2417 3.05207 19.0941 4.90662C20.9465 6.76117 21.9863 9.27564 21.9848 11.8969C21.9825 17.3456 17.5496 21.7768 12.1032 21.7768ZM17.5234 14.3755C17.2264 14.2267 15.7659 13.5085 15.4934 13.4064C15.2209 13.3044 15.0231 13.2576 14.8253 13.5552C14.6275 13.8528 14.058 14.5215 13.8847 14.7199C13.7114 14.9182 13.5381 14.9427 13.241 14.794C12.944 14.6452 11.9869 14.3316 10.8519 13.3198C9.96884 12.5319 9.36969 11.5594 9.19867 11.2618C9.02765 10.9642 9.18043 10.8057 9.32922 10.6552C9.46261 10.5224 9.62622 10.3086 9.77444 10.1348C9.92266 9.9609 9.97283 9.83776 10.0714 9.63938C10.1701 9.44099 10.121 9.26769 10.0469 9.1189C9.97283 8.97011 9.37824 7.50788 9.13083 6.9133C8.88969 6.3341 8.64513 6.4122 8.46271 6.40023C8.29169 6.39168 8.09102 6.38997 7.89264 6.38997C7.58822 6.39793 7.30097 6.53267 7.10024 6.76166C6.82831 7.05923 6.061 7.77752 6.061 9.23976C6.061 10.702 7.12532 12.1146 7.27354 12.313C7.42176 12.5114 9.36855 15.5117 12.3472 16.7989C12.9004 17.0375 13.4657 17.2468 14.0409 17.426C14.7523 17.654 15.3999 17.6204 15.9118 17.544C16.4819 17.4585 17.6694 16.8251 17.9173 16.1313C18.1653 15.4376 18.1648 14.8424 18.0884 14.7187C18.012 14.595 17.8204 14.5266 17.5234 14.3778V14.3755Z" fill="#223843" /></svg>
);
